import React, { useState, useEffect } from 'react';
import { X, Download } from 'lucide-react';

export const InstallPrompt: React.FC = () => {
  const [showPrompt, setShowPrompt] = useState(false);
  const [deferredPrompt, setDeferredPrompt] = useState<any>(null);

  useEffect(() => {
    const handler = (e: Event) => {
      // Prevent Chrome 67 and earlier from automatically showing the prompt
      e.preventDefault();
      // Stash the event so it can be triggered later
      setDeferredPrompt(e);
      // Show our custom prompt
      setShowPrompt(true);
    };

    window.addEventListener('beforeinstallprompt', handler);

    // Check if already installed
    const isInstalled = window.matchMedia('(display-mode: standalone)').matches ||
                       window.navigator.standalone === true;
    
    if (isInstalled) {
      setShowPrompt(false);
    }

    // Show prompt for iOS users
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    if (isIOS && !isInstalled) {
      setShowPrompt(true);
    }

    return () => {
      window.removeEventListener('beforeinstallprompt', handler);
    };
  }, []);

  const handleInstall = async () => {
    // Check if it's iOS
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    
    if (isIOS) {
      // Show iOS-specific instructions
      alert('להתקנת האפליקציה:\n1. לחץ על כפתור "שתף" 📤\n2. בחר "הוסף למסך הבית" 📱');
      setShowPrompt(false);
      return;
    }

    if (!deferredPrompt) return;

    // Show the install prompt
    deferredPrompt.prompt();

    // Wait for the user to respond to the prompt
    const { outcome } = await deferredPrompt.userChoice;
    
    // Clear the deferredPrompt
    setDeferredPrompt(null);
    setShowPrompt(false);
  };

  if (!showPrompt) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 bg-white rounded-lg shadow-lg border border-slate-200 p-4 z-50 animate-slide-up">
      <button 
        onClick={() => setShowPrompt(false)}
        className="absolute top-2 left-2 text-slate-400 hover:text-slate-600"
      >
        <X size={20} />
      </button>
      
      <div className="flex items-center gap-4">
        <div className="flex-grow">
          <h3 className="font-medium text-slate-800 mb-1">
            התקן את האפליקציה
          </h3>
          <p className="text-sm text-slate-600">
            התקן את האפליקציה למסך הבית לגישה מהירה
          </p>
        </div>
        
        <button
          onClick={handleInstall}
          className="flex items-center gap-2 py-2 px-4 bg-emerald-500 text-white rounded-lg hover:bg-emerald-600 transition-colors"
        >
          <Download size={18} />
          <span>התקן</span>
        </button>
      </div>
    </div>
  );
};